import { AsyncAction } from '../../../../base-classes';
import { allStationObservationProvider } from '../../../providers/WeatherStationObservations/StationsList/allStationsObservationProvider';
import { mapParamsToObject } from '../../../../utilities/mapParamsToObject';
import { IStationObservationsData } from "../../../types/APIResponses/WeatherStationObservations/WeatherStationObservationsResponses";
import { IPulseRequestConfiguration, PulseRequestConfiguration } from "../../../types/PulseInterfaces";

export const GET_ALL_STATIONS_OBSERVATION_DATA = new AsyncAction('GET_ALL_STATIONS_OBSERVATION_DATA');
//Type 'string' is not comparable to type 'AsyncAction'
export type ErrorType = {
  type: string;
  payload?: unknown;
}

export type GetAllStationsObservationActionType = {
  type: typeof GET_ALL_STATIONS_OBSERVATION_DATA;
  payload: Promise<IStationObservationsData>;
}

export function getAllStationsObservationDataByLatLon(params: IAllStationsObservationSummary): GetAllStationsObservationActionType {
    let paramsObject = {
        authId: '',
        baseUrl: '',
        directionUnit: 1,
        disableRollover: true,
        distanceUnit: 1,
        fml: false,
        isCached: false,
        latitude: '',
        longitude: '',
        pageNumber: 1,
        pageSize: 0,
        precipitationRateUnit: 1,
        precipitationUnit: 1,
        pressureUnit: 1,
        roundingProfile: 'displayV1',
        searchRadius: 20,
        secret: '',
        speedUnit: 1,
        stationState: '',
        stationType: '',
        stdParameters: '',
        temperatureUnit: 1,
        verbose: false,
    };

    paramsObject = mapParamsToObject(params, paramsObject);
    const apiParameters : IAllStationsObservationSummary = paramsObject;
    
    const requestConfiguration = new PulseRequestConfiguration({
        ...paramsObject,
        verboseResponseKeys: paramsObject.verbose
    });

    return {
        type: GET_ALL_STATIONS_OBSERVATION_DATA.base,
        payload: getAllStationsObservationData({ apiParameters, requestConfiguration })
    };
}

export async function getAllStationsObservationData({ apiParameters, requestConfiguration }: {
    apiParameters: IAllStationsObservationSummary ,
    requestConfiguration: IPulseRequestConfiguration
}): Promise<IStationObservationsData> {
    const {
        authId,
        baseUrl,
        logger,
        options,
        secret
    } = requestConfiguration;
    
    const op = new allStationObservationProvider(baseUrl, authId, secret, options, logger);
    return await op.getAllStationObservationData({ apiParameters, requestConfiguration });
}

export interface IAllStationsObservationSummary {
    authId: string;
    baseUrl: string;
    directionUnit: number;
    disableRollover: boolean;
    distanceUnit: number;
    fml: boolean;
    isCached: boolean;
    latitude: string;
    longitude: string;
    pageNumber: number;
    pageSize: number;
    precipitationRateUnit: number;
    precipitationUnit: number;
    pressureUnit: number;
    roundingProfile: string;
    searchRadius: number;
    secret: string;
    speedUnit: number;
    stationState: string;
    stationType: string;
    stdParameters: string;
    temperatureUnit: number;
    verbose: boolean;
}
